import styled from 'styled-components';

export const Paragraph = styled.p`
  line-height: ${({ lineheight }) => (lineheight ? lineheight : '24px')};
  font-size: ${({ size }) => (size ? size : '12px')};
  font-family: ${({ altFont }) => (altFont ? 'Roboto' : 'Noto Sans')};
  font-weight: ${({ weight }) => (weight ? weight : '500')};
  color: ${({ theme, color }) => (color ? color : theme.black)};
  margin-bottom: ${({mb}) => (mb? mb : '8px')};
  margin-top: ${({mt}) => (mt? mt : '0')};
  text-align: ${({textAlign}) => (textAlign? textAlign : 'left')};
`